// extracted by mini-css-extract-plugin
module.exports = {"tap_By_Index":"TapByIndexV2_tap_By_Index__2bFXE","select_Index":"TapByIndexV2_select_Index__TuIP5","ant-select-selector":"TapByIndexV2_ant-select-selector__23VAr"};